import { RuntimeRepository, UserRepository } from "core/repository";
import { Base2Presenter } from "core/presenter";

class SidebarPresenter extends Base2Presenter {
  initialState() {
    return {
      currentUser: {},
      visible: true,
      navigationTree: []
    };
  }

  async onStart() {
    const states = Object.values(this.router.stateRegistry.states);
    const navigationStates = states.filter(this._stateNavigable);
    const navigation = this._rebuildNavigationFromStateTree(navigationStates);

    this.enqueue({
      navigationTree: navigation,
      currentUser: await this.mRuntime.get(RuntimeRepository.props.currentUser),
      visible: await this.mRuntime.get(RuntimeRepository.props.sidebarOpen)
    });

    this.viewModel.navigationTree = navigation;
    this.viewModel.currentUser = await this.mRuntime.get(
      RuntimeRepository.props.currentUser
    );
    this.viewModel.visible = await this.mRuntime.get(
      RuntimeRepository.props.sidebarOpen
    );

    this.subscribeTo(RuntimeRepository.props.sidebarOpen, visible =>
      this.enqueue({ visible })
    );
    this.subscribeTo(RuntimeRepository.props.currentUser, user =>
      this.enqueue({ currentUser: user })
    );
  }

  async onSignOut() {
    await UserRepository.signOut();
    this.navigateTo("app.login");
  }

  _rebuildNavigationFromStateTree(states) {
    return this._getChildrenStatesFor(states, "app");
  }

  _getChildrenStatesFor(states, stateName) {
    return states
      .filter(this._isChildrenState(stateName))
      .map(this._buildNavigation(states));
  }

  _isChildrenState(stateName) {
    const deconstructedParentName = stateName.split(".");

    return state => {
      const deconstructedChildrenName = state.name.split(".");

      if (
        deconstructedChildrenName.length ===
        deconstructedParentName.length + 1
      ) {
        return deconstructedParentName.every(
          (fragment, index) => fragment === deconstructedChildrenName[index]
        );
      }

      return false;
    };
  }

  _stateNavigable(state) {
    return (
      Object.keys(state).includes("data") &&
      Object.keys(state.data || {}).includes("navigation")
    );
  }

  _buildNavigation(states) {
    return state => ({
      authorization: state.data.authorization,
      ...state.data.navigation,
      children: [
        ...(state.data.navigation.children || []),
        ...this._getChildrenStatesFor(states, state.name)
      ]
    });
  }
}

export default SidebarPresenter;



// WEBPACK FOOTER //
// ./src/components/support/sidebar/presenter.js